import React, { ChangeEvent, memo } from 'react';
import { Card, Typography, Row, Space } from 'antd';
import { FolderOutlined } from '@ant-design/icons';
import { SectionConfig } from '../types/fieldTypes';
import { DynamicField } from './DynamicField';

const { Text } = Typography;

interface DynamicSectionProps {
  section: SectionConfig;
  formData: Record<string, any>;
  onChange: (
    e: ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>
  ) => void;
  mode?: 'edit' | 'view';
}

export const DynamicSection: React.FC<DynamicSectionProps> = memo(
  ({ section, formData, onChange, mode = 'edit' }) => {
    const showBorder = section.customProps?.showBorder !== false;

    return (
      <Card
        title={
          <Space>
            <FolderOutlined />
            <Text strong>{section.title}</Text>
          </Space>
        }
        bordered={showBorder}
        className={section.customProps?.className}
        style={{ marginBottom: 16 }}
      >
        {section.description && (
          <Text type="secondary" style={{ display: 'block', marginBottom: 16 }}>
            {section.description}
          </Text>
        )}

        <Row gutter={[16, 16]}>
          {section.fields.map(field => {
            // Check if field should be visible based on condition
            const isVisible = field.visible ? field.visible(formData) : true;

            // Only render field if it's visible
            if (!isVisible) {
              return null;
            }

            return (
              <DynamicField
                key={field.name}
                field={field}
                value={formData[field.name]}
                onChange={onChange}
                mode={mode}
                formData={formData}
              />
            );
          })}
        </Row>
      </Card>
    );
  }
);

DynamicSection.displayName = 'DynamicSection';
